// /resources/js/app/core/StateManager.js

/**
 * Manages the global state of the application.
 * It reads the initial state from the `window.SGNL` object
 * provided by the Blade template and exports it for other modules to use.
 * This centralizes state management and makes it explicit.
 */

// --- START: THE FIX ---
// Check if window.SGNL exists. If not, we are on a guest page.
const user = window.SGNL ? window.SGNL.user : null;
const config = window.SGNL ? window.SGNL.config : {};
// --- END: THE FIX ---

const isGuest = !user;

console.log('[State Manager] Initialized.', { user, isGuest });

export const StateManager = {
    user,
    config,
    isGuest,
};